import Paragraph from '@pelckmans/elementis/components/paragraph';
import Heading from '@pelckmans/elementis/components/heading';

function ConditionsContentNL() {
  return (
    <>
      <Paragraph>Laatst bijgewerkt op 5/01/2024.</Paragraph>
      <Paragraph>Deze website is eigendom van:</Paragraph>
      <Paragraph>
        <em>
          Pelckmans uitgevers nv
          <br />
          Brasschaatsteenweg 308
          <br />
          2920 Kalmthout
          <br />
          België
        </em>
      </Paragraph>
      <Paragraph>
        E-mailadres: <a href="mailto:uitgeverij@pelckmansuitgevers.be">uitgeverij@pelckmansuitgevers.be</a>
      </Paragraph>
      <Paragraph>
        Ondernemingsnummer: BTW BE 0444.548.723
        <br />
        RPR: Antwerpen
        <br />
        KBC Bank IBAN: BE23 4137 0045 0191
        <br />
        BIC KRED BE BB
      </Paragraph>
      <Paragraph>
        De algemene voorwaarden zoals hier omschreven zijn van toepassing op alle inhoud aangeboden via het leerplatform
        "Pelckmans Portaal" van Pelckmans uitgevers nv. Iedere registratie impliceert de aanvaarding van de algemene
        voorwaarden.
      </Paragraph>
      <Heading level={2}>Artikel 1 – Toepassingsgebied en aanvaarding</Heading>
      <Paragraph>
        <b>1.1.</b> Deze algemene voorwaarden ("Algemene Voorwaarden") zijn van toepassing op het gebruik van de op de
        websites <a href="https://www.pelckmansportaal.be">https://www.pelckmansportaal.be</a>,{' '}
        <a href="https://www.pelckmansportail.be">https://www.pelckmansportail.be</a>,{' '}
        <a href="https://basis.pelckmans.be">https://basis.pelckmans.be</a>,{' '}
        <a href="https://leerkracht-basis.pelckmans.be,">https://leerkracht-basis.pelckmans.be</a>,{' '}
        <a href="https://zogezegd.pelckmans.be">https://zogezegd.pelckmans.be</a>, en de daarmee verbonden websites ,
        modules en applicaties (de “Website(s)”) aangeboden inhoud (de “Inhoud”) die toebehoort aan de NV PELCKMANS
        UITGEVERS met maatschappelijke zetel te 2920 Kalmthout (België), brasschaatsteenweg 308 en met
        Ondernemingsnummer: 0444.548.723 en/of de onder haar ressorterende divisies/uitgeverijen (hierna “Pelckmans”
        genoemd).
      </Paragraph>
      <Paragraph>
        <b>1.2.</b> De gebruiker (hierna “Gebruiker”) is de natuurlijke persoon (leerling/student/cursist - meerderjarig
        ofwel minderjarig mits toestemming van de ouders of voogd-, leerkracht of onderwijsprofessional) die een
        gebruikersaccount heeft aangemaakt op de Website en die inhoud van Pelckmans wenst te gebruiken. Deze Algemene
        Voorwaarden worden aan de Gebruiker meegedeeld bij het aanmelden op de Website. Tijdens het aanmeldingsproces
        zal de Gebruiker uitdrukkelijk zijn akkoord met de Algemene Voorwaarden bevestigen. Het voltooien van de
        aanmelding door de Gebruiker geldt als definitieve aanvaarding van de toepassing van deze Algemene Voorwaarden
        op de verhouding tussen Pelckmans en de Gebruiker.
      </Paragraph>
      <Paragraph>
        <b>1.3.</b> Deze Algemene Voorwaarden gelden niettegenstaande andersluidende voorwaarden van de Gebruiker. Door
        aanvaarding van deze Algemene Voorwaarden verzaakt de Gebruiker volledig aan de toepassing van zijn eigen
        algemene voorwaarden.
      </Paragraph>
      <Paragraph>
        <b>1.4.</b> Elke afwijking van deze Algemene Voorwaarden is maar tegenstelbaar mits voorafgaand, uitdrukkelijk
        en schriftelijk akkoord van Pelckmans.
      </Paragraph>
      <Heading level={2}>Artikel 2 - De Inhoud</Heading>
      <Paragraph>
        <b>2.1.</b> De Website biedt digitale leermiddelen (“de Inhoud”) aan waar de Gebruiker toegang toe krijgt door
        middel van een activatiecode. De Gebruiker ontvangt een of meerdere activatiecodes bij aanschaf van welbepaalde
        producten van Pelckmans (voor meer informatie:
        <a href="http://www.pelckmansuitgevers.be" target="_blank" rel="noreferrer">
          www.pelckmansuitgevers.be
        </a>{' '}
        of <a href="mailto:helpdesk@pelckmansuitgevers.be">helpdesk@pelckmansuitgevers.be</a>)
      </Paragraph>
      <Paragraph>
        <b>2.2.</b> Een activatiecode mag door maximaal één individuele gebruiker gebruikt worden, tenzij anders bepaald
        door de Uitgever. De geldigheid van het leermiddel kan tevens beperkt zijn in de tijd.
      </Paragraph>
      <Paragraph>
        <b>2.3.</b> Toegang tot de inhoud is voorbehouden aan de Gebruikers, die een gebruiksovereenkomst met Pelckmans
        hebben gesloten door middel van registratie op de Website en aanvaarding van de gebruiksvoorwaarden.
      </Paragraph>
      <Heading level={2}>Artikel 3 - Intellectuele eigendomsrechten</Heading>
      <Paragraph>
        <b>3.1.</b> De Websites, alsook alle onderdelen daarvan, inclusief doch niet beperkt tot teksten, afbeeldingen,
        oefeningen, logo’s, audio- en videofragmenten, lay-out behoren in eigendom toe aan Pelckmans inclusief de daarop
        gevestigde intellectuele eigendomsrechten waaronder doch niet beperkt tot auteursrechten, merkrechten,
        modelrechten, databankrechten en andere vormen van intellectuele eigendomsrechten, minstens beschikt Pelckmans
        over een gebruiksrecht op voormelde onderdelen. Het is de Gebruiker onder geen beding toegestaan om de Websites
        of bepaalde onderdelen daarvan te reproduceren, publiceren of op eender welke andere wijze te gebruiken, zonder
        de voorafgaande schriftelijke toestemming van Pelckmans.
      </Paragraph>
      <Paragraph>
        <b>3.2.</b> Bij vermoeden van misbruik behoudt Pelckmans zich het recht voor om de toegang tot de Website
        tijdelijk of definitief te blokkeren.
      </Paragraph>
      <Paragraph>
        <b>3.3.</b> Bepaalde onderdelen en toepassingen binnen de Website laten de Gebruiker toe om eigen inhoud toe te
        voegen (bv. eigen markeringen, notities, foto’s, documenten, hyperlinks …). Om een goede weergave te garanderen
        verschaft de Gebruiker aan Pelckmans een onbeperkte, kosteloze, overdraagbare licentie om deze toegevoegde
        inhoud te gebruiken, reproduceren, verwerken en mee te delen aan derden voor zover dit nodig is om de diensten
        van de Website aan te bieden.
      </Paragraph>
      <Paragraph>
        <b>3.4.</b> Iedere Gebruiker die inhoud aan de Website toevoegt is verantwoordelijk voor de Intellectuele
        Eigendomsrechten die hier op rusten. De Gebruiker verklaart dat zijn handelingen of de door hem toegevoegde
        inhoud op geen enkele manier een inbreuk uitmaken op de intellectuele eigendomsrechten of eender welke andere
        rechten van enige andere/derde partij. Indien de Gebruiker een schending begaat op vlak van intellectuele
        eigendomsrechten of andere rechten van derden, kunnen deze in geen geval worden toegeschreven aan Pelckmans en
        zal de Gebruiker Pelckmans vrijwaren voor elke klacht of vordering die daaromtrent zou worden gericht aan
        Pelckmans.
      </Paragraph>
      <Paragraph>
        <b>3.5.</b> In afwijking van de voorgaande artikelen, preciseert Pelckmans dat voor de bestanden (afbeeldingen,
        Word-bestanden, video’s, ...) die leerkrachten opladen op Pelckmans Portaal en deze desgevallend delen met de
        Gebruiker, uitsluitend de betreffende leerkrachten hierop intellectuele eigendomsrechten kunnen laten gelden en
        voor deze inhoud de volledige verantwoordelijkheid dragen.
      </Paragraph>
      <Heading level={2}>Artikel 4 - Verantwoordelijkheid</Heading>
      <Paragraph>
        <b>4.1.</b> Behoudens in geval van bedrog, opzettelijke fout of zware fout, kan Pelckmans niet contractueel noch
        buitencontractueel aansprakelijk worden gesteld voor eventuele indirecte, immateriële of gevolgschade die zich
        in hoofde van de Gebruiker zou voordoen ten gevolge van enige tekortkoming van Pelckmans bij de uitvoering van
        haar verplichtingen jegens de Gebruiker met betrekking tot de goede werking en beschikbaarheid van de Website en
        de daarop vermelde informatie.
      </Paragraph>
      <Paragraph>
        <b>4.2.</b> Pelckmans zal zich inspannen om de toegankelijkheid van de Websites te waarborgen, maar is niet
        aansprakelijk voor eventuele directe of indirecte schade als gevolg van tijdelijke of gedeeltelijke
        onbereikbaarheid of andere technische mankementen.
      </Paragraph>
      <Paragraph>
        <b>4.3.</b> De Website en haar inhoud is zo zorgvuldig mogelijk samengesteld. Mochten er desondanks onjuistheden
        voorkomen, dan kan Pelckmans hiervoor niet aansprakelijk gesteld worden. Aan eventuele onjuistheden of
        onvolledigheden kunnen geen rechten ontleend worden. Pelckmans kan evenmin aansprakelijk gesteld worden indien
        zich, door het gebruik van deze Website of de erin opgenomen links, bij de Gebruiker schade zou voordoen van
        welke aard ook, direct of indirect.
      </Paragraph>
      <Paragraph>
        <b>4.4.</b> De Website kan links naar websites van derden bevatten, toegevoegd door Pelckmans of door een
        Gebruiker. Pelckmans is niet verantwoordelijk voor de inhoud, beveiliging, algemene voorwaarden en privacy
        policy van deze vreemde websites.
      </Paragraph>
      <Paragraph>
        <b>4.5.</b> De gebruiker heeft recht op technische ondersteuning bij het gebruik van de Website via{' '}
        <a href="mailto:helpdesk@pelckmansuitgevers.be">helpdesk@pelckmansuitgevers.be</a>.
      </Paragraph>
      <Heading level={2}>Artikel 5 - Geschillen en toepasselijke wetgevingen</Heading>
      <Paragraph>
        <b>5.1.</b> In geval van betwisting van de Gebruiksvoorwaarden zijn uitsluitend de rechtbanken van het
        gerechtelijk arrondissement van Antwerpen bevoegd tot beslechting van het geschil.
      </Paragraph>
      <Paragraph>
        <b>5.2.</b> Het Belgische recht is van toepassing op de overeenkomst tussen de Gebruiker en Pelckmans.
      </Paragraph>
      <Heading level={2}>Artikel 6 - Varia</Heading>
      <Paragraph>
        <b>6.1.</b> De nietigheid of niet-tegenstelbaarheid van een of meer bepalingen van deze Gebruiksvoorwaarden,
        laat de toepassing van de overige bepalingen ervan onverlet.
      </Paragraph>
      <Paragraph>
        <b>6.2.</b> De inhoud van de Websites en van de Gebruiksvoorwaarden kunnen onderhevig zijn aan wijzigingen.
      </Paragraph>
      <Paragraph>
        <b>6.3.</b> Alle persoonsgegevens van de Gebruiker worden vertrouwelijk behandeld door Pelckmans in
        overeenstemming met haar privacy policy zoals hieronder opgenomen.
      </Paragraph>
      <Heading level={3}>Privacy</Heading>
      <Paragraph>
        <b>1.1.</b> Door het aanmaken van een gebruikersaccount door de Gebruiker op de websites{' '}
        <a href="https://www.pelckmansportaal.be">https://www.pelckmansportaal.be</a>,{' '}
        <a href="https://www.pelckmansportail.be">https://www.pelckmansportail.be</a>,{' '}
        <a href="https://basis.pelckmans.be">https://basis.pelckmans.be</a>,{' '}
        <a href="https://leerkracht-basis.pelckmans.be,">https://leerkracht-basis.pelckmans.be</a>,{' '}
        <a href="https://zogezegd.pelckmans.be">https://zogezegd.pelckmans.be</a> verwerkt Pelckmans bepaalde gegevens
        van de Gebruiker.
      </Paragraph>
      <Paragraph>
        <b>1.2.</b> De verwerking van Persoonsgegevens gebeurt volgens het privacybeleid van Pelckmans Uitgevers NV
        terug te vinden op{' '}
        <a href="http://www.pelckmans.be/privacy" target="_blank" rel="noreferrer">
          www.pelckmans.be/privacy
        </a>
        .
      </Paragraph>
    </>
  );
}

export default ConditionsContentNL;
